// extracted by mini-css-extract-plugin
module.exports = {"headHeight":"0.416667rem","footHeight":"1.041667rem","breadcrumbHeight":"0.347222rem","bgGray":"#f8f8f9","scrollbarWidth":"0.041667rem"};